import { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-kml';
import JSZip from 'jszip';

export default function Mapa({ ubicacion }) {
    useEffect(() => {
        const map = L.map('map').setView([ubicacion?.lat || -32.41469454047811, ubicacion?.lng || -63.2423299238929], ubicacion?.zoom || 13);

        L.tileLayer('http://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
            attribution: 'Map data ©2024 Google',
        }).addTo(map);

        // Cargar archivo KMZ usando leaflet-kml
        fetch('./mapa.kmz')
            .then(res => res.arrayBuffer())
            .then(arrayBuffer => {
                const zip = new JSZip();
                return zip.loadAsync(arrayBuffer);
            })
            .then(zip => {
                const kmlFile = zip.file(/\.kml$/i)[0];
                if (!kmlFile) {
                    throw new Error('No KML file found in KMZ');
                }
                return kmlFile.async('text');
            })
            .then(kmlText => {
                const parser = new DOMParser();
                const kml = parser.parseFromString(kmlText, 'text/xml');
                const kmlLayer = new L.KML(kml);
                const bounds = kmlLayer.getBounds();
                if (bounds.isValid()) {
                    map.addLayer(kmlLayer);
                    map.fitBounds(bounds);
                } else {
                    console.error('Invalid bounds:', bounds);
                }
            })
            .catch(e => {
                console.log('Error loading KMZ:', e);

            });

        return () => {
            map.remove();
        };
    }, [ubicacion]);

    return <div id="map" style={{ height: '100%', width: '100%' }} />;
}